// Admins may add applications only within the campaign's application period (same rule as the backend).
export const isAcceptingApplications = campaign => {
  if (!campaign?.applicationStartTimestamp || !campaign?.applicationEndTimestamp) return false;

  const now = new Date();
  return new Date(campaign.applicationStartTimestamp) <= now && now < new Date(campaign.applicationEndTimestamp);
};
